import { Button, Grid, Stack, Typography } from "@mui/material";
import { useState } from "react";
import BusinessIcon from "@mui/icons-material/Business";

const selectedStyle = {
  borderBottom: "4px solid #FF2C04"
};

const CustomInput = (props) => (
  <input
    style={{
      backgroundColor: "transparent",
      width: "100%",
      height: "100%",
      textAlign: "center",
      border: "none",
      fontSize: 18,
      outline: "none"
    }}
    {...props}
  />
);
export default function Domain() {
  const [selected, setSelected] = useState("cloudflare");
  return (
    <div>
      <Typography variant="h3">Your Domains</Typography>
      <Typography variant="h4">Link Your Custom Domain</Typography>
      <Container>
        <Grid container spacing={0} sx={{ textAlign: "center" }}>
          <Grid
            item
            xs={6}
            sx={selected === "cloudflare" ? selectedStyle : {}}
            onClick={() => setSelected("cloudflare")}
          >
            <Typography>With Cloudflare</Typography>
          </Grid>
          <Grid
            item
            xs={6}
            sx={selected !== "cloudflare" ? selectedStyle : {}}
            onClick={() => setSelected("cname")}
          >
            <Typography>With CNAME mapping</Typography>
          </Grid>
        </Grid>
        <p>
          To activate your custom domain, you need to create new CNAME records
          in your DNS dashboard
        </p>
        <br />
        <p>Please refer to this guide for step by step process</p>
        <Typography variant="h6">Enter your domain name</Typography>
        <Grid
          container
          spacing={0}
          style={{
            border: "1px solid gray",
            textAlign: "center"
          }}
        >
          <Grid item xs={2} sx={{ backgroundColor: "white", p: 1 }}>
            <CustomInput placeholder="https://" />
          </Grid>
          <Grid item xs={8} sx={{ p: 1 }}>
            <CustomInput placeholder="website.com" />
          </Grid>
          <Grid item xs={2} sx={{ backgroundColor: "white", p: 1 }}>
            <Stack direction="row">
              <BusinessIcon />
              <span>Set Primary</span>
            </Stack>
          </Grid>
        </Grid>
        <span>For example www.example.com or courses.example.com</span>
        <Stack direction="row" justifyContent="space-between">
          <Button>Delete Domain</Button>
          <Button variant="contained">Next</Button>
        </Stack>
      </Container>
    </div>
  );
}

const Container = (props) => (
  <div
    style={{ padding: 16, marginBottom: 16, backgroundColor: "#eee" }}
    {...props}
  />
);
